/*
 * File Created: Thursday, 18th May 2023 9:20:51 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

import Box, { BoxProps } from "@mui/material/Box";
import React from 'react'
import { SiteLink } from "../../types/static/StaticModal.type";
import { Icons } from "../../MediaIcon";

type SocialMediaProps = BoxProps & SiteLink;

function SocialMediaIcon({ name, src, sx, ...rest }: SocialMediaProps) {
  const iconData = Icons.find((icon) => icon.name === name)
  return (
    <Box
        key={name}
        component='a'
        href={src}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          color: iconData?.color,
          textDecoration: 'none',
          cursor: 'pointer',
          ...sx,
        }}
        {...rest}
    >
      {iconData?.icon}
    </Box>
  )
}

export default SocialMediaIcon